import { URLConfig } from '../../models';

export const DEFAULT_URL_CONFIG: URLConfig = {
  keepURLEncoding: false,
  queryDefaultMappings: {
    filters: 'filter',
    page: 'page',
    query: 'q',
    firstGridItemIdInView: 'scroll',
    sort: 'sort',
    relatedTags: 'tag'
  },
  queryAdditionalMappings: {}
};
